import React, { useEffect, useState } from 'react';
import { API_ENDPOINTS } from '../../utils/endpoints';
import { useDispatch, useSelector } from 'react-redux';
import {
    getOnboardingData,
    setOnboardingData
} from '../../../../redux/onboardingSlice';
import { http_put } from '../../utils/api_client';

const INDUSTRIES = [
    'SaaS / Software',
    'Financial services',
    'Healthcare',
    'E-commerce / Retail',
    'Education',
    'Agency / Consulting',
    'Manufacturing',
    'Other'
];

export const CompanyStepTitle = () => (
    <div>
        <h1 className="un-auth__q">Tell us about your company</h1>
        <p className="un-auth__sub">This sets up your workspace and your learners' portal.</p>
    </div>
);

const CompanyStep = ({ onChangeStep }) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => getOnboardingData(state));
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [error, setError] = useState(null);

    const saveData = () => {
        setIsLoading(true);
        setError(null);
        http_put(API_ENDPOINTS.PUT_COMPANY, { company_name: data.companyName })
            .then((res) => {
                if (res?.data?.domain) {
                    dispatch(setOnboardingData({ domain: res.data.domain }));
                }
                if (data.industryName) {
                    return http_put(API_ENDPOINTS.PUT_USER_BIO, {
                        bio: { industry_name: data.industryName }
                    });
                }
                return null;
            })
            .then(() => onChangeStep())
            .catch((err) => {
                setError(err?.response?.data?.error || err?.response?.data?.message || 'Something went wrong. Please try again.');
            })
            .finally(() => setIsLoading(false));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(setOnboardingData({ [name]: value }));
    };

    useEffect(() => {
        setIsDisabled(!data.companyName);
    }, [data]);

    return (
        <>
            <div className="un-auth__field">
                <div className="un-auth__label">Company name</div>
                <input type="text" name="companyName" placeholder="Acme Inc." value={data.companyName || ''} onChange={handleChange} />
            </div>
            <div className="un-auth__field">
                <div className="un-auth__label">What do you do?</div>
                <select name="industryName" value={data.industryName || ''} onChange={handleChange}>
                    <option value="">Select industry</option>
                    {INDUSTRIES.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                    ))}
                </select>
            </div>
            {error && <p className="un-auth__err" role="alert">{error}</p>}
            <button className="un-auth__btn un-auth__btn--primary" onClick={saveData} disabled={isDisabled || isLoading}>
                {isLoading ? 'Saving…' : 'Continue'}
            </button>
        </>
    );
};

export default CompanyStep;
